import styled from 'styled-components';

export const PartyJackpotWelcomePopupContainerBox = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: ${props => props.theme.colors.background};

    width: 470px;
    padding: 50px 40px 70px 40px;
    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        width: 100%;
        padding: 30px 20px 40px 20px;
        @media ${({theme}) => theme.mediaQuery.landscape} {
            width: 550px;
            padding: 10px 10px 20px 10px;
        }
    }

    & a {
        margin: 0 auto;
        margin-top: 10px;
        cursor: pointer;
        text-decoration: underline;
    }
`;
